import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (!c) setOpen(true);
    else setMarketing(!!c.marketing);
    const reopen = () => { const cur = getConsent(); setMarketing(!!(cur && cur.marketing)); setPrefs(true); setOpen(true); };
    window.addEventListener("rl-open-cookie-prefs", reopen);
    return () => window.removeEventListener("rl-open-cookie-prefs", reopen);
  }, []);

  const save = (m) => { setConsent(m); setOpen(false); setPrefs(false); };
  if (!open) return null;

  return (
    <div role="dialog" aria-modal="false" aria-labelledby="cookie-title" className="fixed bottom-3 left-3 right-3 z-[60] sm:left-auto sm:right-5 sm:bottom-5 sm:w-[440px]" data-testid="cookie-banner">
      <div className="rounded-2xl border border-[#E7E5DF] bg-white p-6 text-[#2C2C2A] shadow-[0_30px_80px_-30px_rgba(19,53,47,0.45)]" style={{ animation: "rl-step-in .6s cubic-bezier(.16,1,.3,1) both" }}>
        <div className="flex items-center gap-2">
          <Cookie size={18} className="text-[#0F6E56]" />
          <p id="cookie-title" className="font-display text-[17px]">Cookie, in breve</p>
        </div>
        <p className="mt-3 text-[14px] leading-relaxed text-[#2C2C2A]/85">
          Usiamo cookie tecnici per far funzionare il sito. Con il tuo consenso usiamo anche cookie di marketing per misurare le campagne. Dettagli nella{" "}
          <Link to="/cookie" className="font-medium text-[#0F6E56] underline underline-offset-4" data-testid="cookie-policy-link">Cookie policy</Link>.
        </p>
        {prefs && (
          <div className="mt-5 space-y-3 rounded-xl bg-[#F7F6F2] p-4 text-[14px]" data-testid="cookie-preferences-panel">
            <div className="flex items-center justify-between gap-4">
              <span><span className="font-medium">Tecnici</span><span className="block text-[12.5px] text-[#6B6961]">Necessari, sempre attivi</span></span>
              <input type="checkbox" checked disabled className="h-5 w-5 accent-[#0F6E56]" aria-label="Cookie tecnici, sempre attivi" />
            </div>
            <label className="flex cursor-pointer items-center justify-between gap-4">
              <span><span className="font-medium">Marketing</span><span className="block text-[12.5px] text-[#6B6961]">Misura delle campagne pubblicitarie</span></span>
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="h-5 w-5 accent-[#0F6E56]" data-testid="cookie-marketing-toggle" />
            </label>
          </div>
        )}
        <div className="mt-5 flex flex-wrap gap-2">
          {prefs ? (
            <button type="button" onClick={() => save(marketing)} className="rl-btn rl-btn-amber !h-11 flex-1" data-testid="cookie-save-button">Salva preferenze</button>
          ) : (
            <>
              <button type="button" onClick={() => save(true)} className="rl-btn rl-btn-amber !h-11 flex-1" data-testid="cookie-accept-button">Accetta</button>
              <button type="button" onClick={() => save(false)} className="rl-btn rl-btn-ghost !h-11 flex-1" data-testid="cookie-reject-button">Rifiuta</button>
              <button type="button" onClick={() => setPrefs(true)} className="rl-btn !h-11 w-full !px-4 text-[#0F6E56] hover:bg-[#BCE3D6]/40" data-testid="cookie-preferences-button">Preferenze</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
